import { observer } from 'mobx-react';
import * as React from 'react';
import GroupStore from '../../../GroupStore';
import Reactions from '../../../GroupStore/Reactions';
import GroupsStore from '../../../GroupsStore';
import GroupsOptionsReactions from '../../../GroupsStore/Options/Reactions';
import GroupsReactions from '../../../GroupsStore/Reactions';
import { GroupResource } from '../../../GroupsStore/Types';
import { MulticheckStore } from '../../../Multicheck/Store';
import { T } from '../../../Translations';
import ModalStore from '../../Modal/Store';
import AddGroup from './AddGroup';
import GroupsState from './GroupsState';

@observer
class Groups extends React.Component<{}, {}> {
  private groupsStore: GroupsStore = new GroupsStore();
  // modalStore is dead code — the only consumer (AddEditGroupModal) was
  // retired when Add Group moved to a full page. Kept here and in the
  // prop drilling through GroupsState/GroupsView/TableOrEmpty/Table/* so
  // this diff stays focused; a separate cleanup can strip it.
  private modalStore: ModalStore = new ModalStore();
  private groupStore: GroupStore = new GroupStore(this.groupsStore);
  private multicheckStore: MulticheckStore<GroupResource> = new MulticheckStore();

  componentDidMount(): void {
    this.groupsStore.loading(1);
  }

  render() {
    return (
      <>
        <div className="mt-7">
          <div className="max-w-clientPortalMaxWidth mx-auto w-full overflow-x-hidden">
            <div className="md:flex-row lg:px-12">
              <div className="flex justify-between">
                <h2 className="text-2xl font-semibold text-gray-900 items-center">
                  <T kind="Groups" />
                </h2>
                <AddGroup groupsStore={this.groupsStore} />
              </div>
            </div>
          </div>
        </div>
        <div className="max-w-clientPortalMaxWidth mx-auto">
          <GroupsState
            store={this.groupsStore}
            modalStore={this.modalStore}
            groupStore={this.groupStore}
            multicheckStore={this.multicheckStore}
          />
          <GroupsReactions store={this.groupsStore} fireImmediately />
          <GroupsOptionsReactions store={this.groupsStore.optionsStore} fireImmediately />
          <Reactions store={this.groupStore} fireImmediately />
        </div>
      </>
    );
  }
}

export default Groups;
